import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMagnifyingGlassLight = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 96,
	height: 96,
	viewBox: "0 0 96 96",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_15765_31565)",
		children: [
			/* @__PURE__ */ _jsx("rect", {
				width: 76,
				height: 22,
				rx: 4,
				transform: "matrix(1 0 -0.533024 0.8461 20 33)",
				fill: "#8588D8"
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 61.6797,
				height: 22,
				rx: 4,
				transform: "matrix(1 0 -0.533024 0.8461 28.7266 28)",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: .233488,
				y: .42305,
				width: 60.6797,
				height: 21,
				rx: 3.5,
				transform: "matrix(1 0 -0.533024 0.8461 28.9521 28.0651)",
				stroke: "black",
				strokeOpacity: .94
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 50.4733,
				height: 22,
				rx: 4,
				transform: "matrix(1 0 -0.533024 0.8461 37.7266 20)",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: .233488,
				y: .42305,
				width: 49.4733,
				height: 21,
				rx: 3.5,
				transform: "matrix(1 0 -0.533024 0.8461 37.9521 20.0651)",
				stroke: "black",
				strokeOpacity: .94
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.90521 89.3928L37.5453 86.4619L46.6328 65.457L34.0261 65.9455L24.7523 78.6461L2.90521 89.3928Z",
				fill: "#8588D8"
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 24,
				cy: 24,
				r: 23,
				transform: "matrix(0.908211 0.257882 -0.469765 0.942321 46.4492 0)",
				stroke: "#4F49BA",
				strokeWidth: 2
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M77.4636 34.1368C71.6159 45.8669 57.6599 52.7684 46.2875 49.5392C34.915 46.3101 30.4479 34.1774 36.2956 22.4474C42.1432 10.7173 56.0992 3.81578 67.4717 7.04494C78.8442 10.2741 83.3113 22.4067 77.4636 34.1368Z",
				fill: "white",
				stroke: "#4F49BA",
				strokeWidth: 2
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: .219223,
				y: .600102,
				width: 7,
				height: 37,
				rx: 3.5,
				transform: "matrix(0.908211 0.257882 -0.469765 0.942321 40.0169 55.0787)",
				fill: "white",
				stroke: "#4F49BA"
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 2,
				height: 7,
				transform: "matrix(0.908211 0.257882 -0.469765 0.942321 45.2578 50.2207)",
				fill: "#4F49BA"
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 5,
				height: 1,
				transform: "matrix(0.908211 0.257882 -0.469765 0.942321 26.0938 82.4277)",
				fill: "#4F49BA"
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 5,
				height: 1,
				transform: "matrix(0.908211 0.257882 -0.469765 0.942321 28.4414 77.7168)",
				fill: "#4F49BA"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.88171 78.3374C2.61718 83.7624 2.20129 89.0841 2.10788 91.0381C1.96563 91.6894 4.98113 92.992 10.1811 92.992C15.3811 92.992 19.299 91.6893 20.6079 91.038L21.3881 85.1762C21.3148 83.2223 20.8362 83.1246 18.9215 82.7338C17.0069 82.343 18.3979 82.5542 18.3979 82.5542C18.3979 82.5542 22.7416 81.2683 26.4884 77.8489C27.7114 76.7327 32.3655 70.5549 34.7554 67.2395C35.2452 66.5601 36.0421 66.126 36.8182 66.1198C39.9583 66.0948 44.9945 65.9766 47.1555 65.6368C48.117 65.4856 49.5224 65.0372 50.9024 64.5064C53.0897 63.665 55.2129 62.6168 55.4023 62.2174C55.4023 62.2174 58.3625 57.821 50.4692 57.3326C49.6605 57.2825 48.8395 57.2171 48.0108 57.1421C40.7499 56.4847 34.1093 54.4017 27.5759 56.8441C21.0424 59.2865 12.2224 60.752 4.88171 78.3374Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M48.0108 57.1421C40.7499 56.4847 34.1093 54.4017 27.5759 56.8441C21.0424 59.2865 12.2224 60.752 4.88171 78.3374C2.61718 83.7624 2.20129 89.0841 2.10788 91.0381C1.96563 91.6894 4.98113 92.992 10.1811 92.992C15.3811 92.992 19.299 91.6893 20.6079 91.038L21.3881 85.1762C21.3148 83.2223 20.8362 83.1246 18.9215 82.7338C17.0069 82.343 18.3979 82.5542 18.3979 82.5542C18.3979 82.5542 22.7416 81.2683 26.4884 77.8489C27.7114 76.7327 32.3655 70.5549 34.7554 67.2395C35.2452 66.5601 36.0421 66.126 36.8182 66.1198C39.9583 66.0948 44.9945 65.9766 47.1555 65.6368C48.117 65.4856 49.5224 65.0372 50.9024 64.5064C53.0897 63.665 55.2129 62.6168 55.4023 62.2174C55.4023 62.2174 58.3625 57.821 50.4692 57.3326C49.6605 57.2825 48.8395 57.2171 48.0108 57.1421ZM48.0108 57.1421C47.7835 58.1825 51.1291 60.2634 54.3291 60.2634",
				stroke: "black",
				strokeOpacity: .94,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M51.1963 64.4805C52.4117 65.0201 54.544 67.4671 54.2026 69.0303C53.7758 70.9842 51.2424 73.4267 50.6357 73.9151C51.209 75.8691 49.6755 78.3115 48.3555 79.777C47.0354 81.2424 45.9287 81.7309 45.9287 81.7309C45.2042 83.522 43.6819 85.1503 41.4686 86.1273C40.0357 86.7597 35.3316 88.2812 30.2704 87.0347C29.2717 86.7887 28.9707 86.6655 28.4996 86.5004C22.9264 84.5464 25.2447 83.4895 26.2154 82.7079C27.1861 81.9263 28.9043 81.0796 29.6421 80.7539C28.3555 79.777 28.7822 77.823 30.1023 76.3576C30.4072 76.019 30.9241 75.7538 31.5451 75.5478C33.0749 75.0404 35.2369 74.8921 36.4223 74.8921C34.029 74.4036 33.512 73.9483 33.4558 72.4497C33.4229 71.5741 33.9925 70.6986 35.0102 69.9109C36.2638 68.9408 38.1972 68.104 40.5226 67.5648L51.1963 64.4805Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M47.4494 65.6109C48.4108 65.4597 49.8163 65.0113 51.1963 64.4805M51.1963 64.4805C52.4117 65.0201 54.544 67.4671 54.2026 69.0303C53.7758 70.9842 51.2424 73.4267 50.6357 73.9151M51.1963 64.4805L40.5226 67.5648C38.1972 68.104 36.2638 68.9408 35.0102 69.9109M50.6357 73.9151C50.029 74.4036 38.8157 75.3806 36.4223 74.8921M50.6357 73.9151C51.209 75.8691 49.6755 78.3115 48.3555 79.777C47.0354 81.2424 45.9287 81.7309 45.9287 81.7309M36.4223 74.8921C34.029 74.4036 33.512 73.9483 33.4558 72.4497C33.4229 71.5741 33.9925 70.6986 35.0102 69.9109M36.4223 74.8921C35.2369 74.8921 33.0749 75.0404 31.5451 75.5478M45.9287 81.7309C41.1909 82.0566 30.6714 81.5355 29.6421 80.7539M45.9287 81.7309C45.2042 83.522 43.6819 85.1503 41.4686 86.1273C40.0357 86.7597 35.3316 88.2812 30.2704 87.0347M29.6421 80.7539C28.3555 79.777 28.7822 77.823 30.1023 76.3576C30.4072 76.019 30.9241 75.7538 31.5451 75.5478M29.6421 80.7539C28.9043 81.0796 27.1861 81.9263 26.2154 82.7079C25.2447 83.4895 22.9264 84.5464 28.4996 86.5004C28.9707 86.6655 29.2717 86.7887 30.2704 87.0347M35.0102 69.9109C36.3121 69.2917 36.9758 70.9842 37.3491 72.9382M31.5451 75.5478C33.8264 76.1434 32.5689 78.8 31.9622 79.2885M30.2704 87.0347C30.872 86.5694 31.1119 84.8572 29.768 83.6849",
				stroke: "black",
				strokeOpacity: .94,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M49.4967 41.5625C54.7434 41.5625 59.9043 37.4071 61.0238 32.2812C61.2396 31.2929 61.2895 30.3406 61.1917 29.4473C60.2758 30.8401 58.6464 31.8158 56.9967 31.8158C54.7876 31.8158 53.3788 30.0661 53.8502 27.9079C54.2565 26.0477 55.9268 24.4911 57.7948 24.0966C56.6121 23.3969 55.1722 23 53.5508 23C48.3041 23 43.1432 27.1553 42.0238 32.2812C40.9043 37.4071 44.25 41.5625 49.4967 41.5625Z",
				fill: "black",
				fillOpacity: .94
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M24.5 87L27 88",
				stroke: "#4F49BA",
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M24 89L26.5 90",
				stroke: "#4F49BA",
				strokeLinecap: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_15765_31565",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 96,
			height: 96,
			fill: "white"
		})
	}) })]
});
export default SvgMagnifyingGlassLight;
